/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Copy_Error_IdInputs */

const de_commons_error_page_copy_error_id = /** @type {(inputs: Commons_Error_Page_Copy_Error_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler-ID kopieren`)
};

/** @type {(inputs: Commons_Error_Page_Copy_Error_IdInputs) => LocalizedString} */
const en_commons_error_page_copy_error_id = de_commons_error_page_copy_error_id;

/**

* @param {Commons_Error_Page_Copy_Error_IdInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_copy_error_id = /** @type {((inputs?: Commons_Error_Page_Copy_Error_IdInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Copy_Error_IdInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_copy_error_id(inputs)
	return en_commons_error_page_copy_error_id(inputs)
});